<template>
  <div class="range--popup">
    <div class="range--popup--box">
      <span v-if="label" v-html="label" class="range--popup--label"></span>
      <vue-slider v-model="value" :tooltip-formatter="formatter" :included="true" :data="data" :min="min" :max="max" :enable-cross="false" :marks="marks" @change="$emit('input', value)" />
    </div>
    <div class="range--backdrop" @click="$emit('close')"></div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/material.css'

export default {
  name: 'PricePopup',
  components: {
    VueSlider
  },
  data: () => ({
      value: []
  }),
  mounted () {
    this.setValues()
  },
  props: {
    from: { default: null },
    to: { default: null },
    marks: { default: true },
    data: { default: null },
    min: { default: null },
    max: { default: null },
    label: { default: null }
  },
  methods: {
    setValues () {
      this.value = [this.from, this.to]
    },
    formatter (value) {
      return this.kFormatter(value)
    },
    kFormatter(num) {
      return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
    }
  }
}
</script>

<style lang="scss">
@import "../../../scss/global/includes";

.range--popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1009;
  color: $primary-grey;
}

.range--popup--box {
  width: 50vw;
  max-width: 100%;
  padding: 5vw;
  background: #FFFFFF;
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  @include transform(translate(-50%, -50%)!important);
  z-index: 1009;
  max-width: none;
  box-shadow: rgba(0,0,0, 0.2) 0 6px 20px;

  .vue-slider-mark-label {
    font-size: 12px;
    color: $dark-grey;
  }

  @include breakpoint(tablet-landscape) {
    width: 600px;
  }
  @include breakpoint(tablet) {
    padding: 22px;
    width: 90vw;
    .vue-slider-mark-label {
      font-size: 10px;
    }
  }
}

.range--backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
}

.vue-slider-process, .vue-slider-dot-handle, .vue-slider-dot-tooltip-inner, .vue-slider-mark-step {
	background-color: $primary;
}

.vue-slider-rail, .vue-slider-dot-handle::after {
	background-color: $primary-faded;
}

.vue-slider-rail {
  background-color: $primary;
  height: 1px!important;
} 

.vue-slider-dot {
  width: 12px!important;
  height: 12px!important;
}

.vue-slider-mark {
  width: 5px!important;
  height: 5px!important;
}

.vue-slider-process {
  height: 2px!important;
  top: -0.5px!important;
}

.range--popup--label {
  @include responsive-text-size('Header--12--BOLD');
  position: absolute;
  top: 2.5vw;
  left: 50%;
  transform: translateX(-50%);
  @include breakpoint(tablet) {
    top: 8px;
  }
}

</style>